// extracted by mini-css-extract-plugin
module.exports = {"row":"Notification_row__k27rc","col":"Notification_col__39Vpa"};